<template>
  <MultiselectObjects
    v-bind="$attrs"
    :value="value"
    :options="options"
    track-by="value"
    label="label"
    :loading="isLoading"
    :required="required"
    :state="state"
    :disabled="disabled"
    :placeholder="placeholder"
    @input="onInput"
    @search-change="onSearch"
  >
    <template #noOptions>Type to search</template>
  </MultiselectObjects>
</template>

<script>
import { debounce, uniqBy } from 'lodash'

import MultiselectObjects from '@/components/MultiselectObjects.vue'
import { http2 } from '@/services/http.js'

export default {
  name: 'LookupMultiselect',
  components: { MultiselectObjects },
  inheritAttrs: false,
  props: {
    value: [Number, String],
    api: { type: String, required: true },
    initialOption: { type: Object, default: null },
    disabled: Boolean,
    required: Boolean,
    state: { type: Boolean, default: undefined },
    placeholder: { type: String, default: 'Search' },
    minChars: { type: Number, default: 3 },
  },
  data() {
    return {
      options: this.initialOption ? [this.initialOption] : [],
      selectedOption: this.initialOption,
      isLoading: false,
      requestToken: 0,
    }
  },
  watch: {
    initialOption(option) {
      if (!option) return
      this.selectedOption = option
      this.options = uniqBy([option, ...this.options], 'value')
    },
    value(value) {
      if (value == null) {
        this.selectedOption = null
        return
      }
      const option = this.options.find(item => String(item.value) === String(value))
      if (option) this.selectedOption = option
    },
  },
  created() {
    this.debouncedFetchOptions = debounce(this.fetchOptions, 200)
  },
  beforeDestroy() {
    this.debouncedFetchOptions.cancel()
  },
  methods: {
    onInput(value) {
      this.selectedOption = this.options.find(option => String(option.value) === String(value)) || null
      this.$emit('input', value)
    },
    onSearch(term) {
      this.$emit('error', undefined)
      const query = String(term || '').trim()
      if (query.length < this.minChars) {
        this.debouncedFetchOptions.cancel()
        this.requestToken++
        this.isLoading = false
        this.options = this.selectedOption ? [this.selectedOption] : []
        return
      }
      this.debouncedFetchOptions(query)
    },
    async fetchOptions(term) {
      const token = ++this.requestToken
      this.isLoading = true
      try {
        const response = await http2.get(this.api, { params: { term } })
        if (token !== this.requestToken) return
        this.options = uniqBy([
          ...(this.selectedOption ? [this.selectedOption] : []),
          ...(response.data || []),
        ], 'value')
      } catch (error) {
        if (token === this.requestToken) this.$emit('error', error)
      } finally {
        if (token === this.requestToken) this.isLoading = false
      }
    },
  },
}
</script>
